import React, { createContext, useState, ReactNode, useContext } from 'react';

interface AppointmentContextProps {
  // Define your context properties here
}

const AppointmentContext = createContext<AppointmentContextProps | undefined>(undefined);

export const AppointmentProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Define your state and context values here

  return (
    <AppointmentContext.Provider value={{ /* context values */ }}>
      {children}
    </AppointmentContext.Provider>
  );
};

export const useAppointmentContext = () => {
  const context = useContext(AppointmentContext);
  if (context === undefined) {
    throw new Error('useAppointmentContext must be used within a AppointmentProvider');
  }
  return context;
};